exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#system-configuration-tabs .v-tabs__item.v-tabs__item--active {\n    color: #D2202F;\n    font-weight: bold;\n}\n", ""]);

// exports
